import { render, staticRenderFns } from "./GalleryStep.vue?vue&type=template&id=0eda8436&scoped=true&"
var script = {}
import style0 from "./GalleryStep.vue?vue&type=style&index=0&id=0eda8436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eda8436",
  null
  
)

export default component.exports